import Vue from 'vue';

/**
 * A utility component that simply reflects all attrs back as
 * slot props to the default slot. This is useful for creating
 * intermediate state within a template, e.g. transforming data, that
 * isn't easily done using computed props. A common scenario would be
 * within a v-for loop.
 * See https://github.com/posva/vue-local-scope for a module that
 * works similarly, but seemed to have problems and is unnecessary
 * for such a simple solution.
 */
export default Vue.extend({
  functional: true,

  render: (_, context) => context.scopedSlots.default({
    ...context.data.attrs
  })[0]
});
